module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.searchForm,
      "inline": true,
      "label-position": _vm.position
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "应用名称",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.name),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "name", $$v)
      },
      expression: "searchForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "主版本号",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.mainVersion),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "mainVersion", $$v)
      },
      expression: "searchForm.mainVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "版本号",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.version),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "version", $$v)
      },
      expression: "searchForm.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "构建号",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.buildCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "buildCode", $$v)
      },
      expression: "searchForm.buildCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "是否上线",
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.state),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "state", $$v)
      },
      expression: "searchForm.state"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "上线",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未上线",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "应用名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mainVersion",
      "label": "主版本号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "版本号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buildCode",
      "label": "构建号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "是否上线"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.state == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("上线")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("未上线")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "memo",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "创建时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.searchForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.searchForm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.searchForm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情信息",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formLoading),
      expression: "formLoading"
    }],
    ref: "formRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.modelInfo,
      "label-position": 'right',
      "inline": true,
      "rules": _vm.formRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应用名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "name", $$v)
      },
      expression: "modelInfo.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主版本号",
      "prop": "mainVersion"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.mainVersion),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "mainVersion", $$v)
      },
      expression: "modelInfo.mainVersion"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "版本号",
      "prop": "version"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.version),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "version", $$v)
      },
      expression: "modelInfo.version"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "构建号",
      "prop": "buildCode"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.buildCode),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "buildCode", $$v)
      },
      expression: "modelInfo.buildCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "wgt地址",
      "prop": "wgtUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.wgtUrl),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "wgtUrl", $$v)
      },
      expression: "modelInfo.wgtUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "pkg地址",
      "prop": "pkgUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.pkgUrl),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "pkgUrl", $$v)
      },
      expression: "modelInfo.pkgUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否上线",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "是否上线",
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.state),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "state", $$v)
      },
      expression: "modelInfo.state"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "上线",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未上线",
      "value": 0
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "备注",
      "clearable": ""
    },
    model: {
      value: (_vm.modelInfo.memo),
      callback: function($$v) {
        _vm.$set(_vm.modelInfo, "memo", $$v)
      },
      expression: "modelInfo.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24,
      "id": "recovery-shop-apk-version-upload"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文件上传"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader fl",
    attrs: {
      "data": _vm.postData,
      "accept": _vm.acceptImage,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fileUrl))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-b3c10916","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/recovery/recoveryShopApkVersion.vue
// module id = 1735
// module chunks = 0